import styled from 'styled-components';

import { flexStart } from '../../../style/reusableStyle';

export const ViewJobContainerStyled = styled.div`
  margin: 18px 0px 200px;
  width: 100%;
  /* padding: 20px 30px; */

  & .container {
    margin-left: 30px;
  }

  & .title {
    margin-bottom: 12px;
  }
  & .contents {
    margin-left: 30px;
  }
  & .heading {
    margin-bottom: 30px;
    ${flexStart};
    gap: 50px;
  }

  & .profile {
    display: flex;
    /* align-items: center; */
    gap: 10px;
  }
`;
export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 30px;
`;
export const ProfileCOntainer = styled.div`
  ${flexStart};
  flex-direction: column;
  width: 188px;
  gap: 10px;
`;
export const DescriptionContainer = styled.div`
  flex: 1;

  /* max-width:; */
`;
export const InfoRow = styled.div`
  /* width: 100%; */
  display: flex;
  align-items: flex-start;

  gap: 20px;
  margin-bottom: 20px;
  & .title {
    width: 180px;
    color: ${({ theme }) => theme.colors.tabText};
    flex-shrink: 0;
  }
  & .value {
    color: ${({ theme }) => theme.colors.normalText};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;

    & .title {
      font-weight: 600;
    }
  }
`;

export const HistoryContainer = styled.div`
  & .date {
    color: #949494;
  }

  & .proposalContainer {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
  }

  & .proposalContent {
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    gap: 5px;
  }
`;
